import { Tab, TabProps, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Standard Tab to be used for logged in and out app states inside Tab Bar.
 * @returns {JSX.Element}
 */
const PrimaryTab = styled(Tab)<TabProps>(({ theme }) => ({
  boxSizing: 'border-box',
  color: theme.palette.secondary.main,
  minWidth: 175,
  textTransform: 'none',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: 8,
  padding: '0 3',
  fontSize: theme.typography.body1.fontSize,
  minHeight: '42px',
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    border: 'none',
    color: theme.palette.primary.contrastText
  },
  '&.Mui-disabled': {
    color: alpha(theme.palette.secondary.main, 0.5),
    border: `1px solid ${alpha(theme.palette.secondary.main, 0.4)}`
  }
}));

export default PrimaryTab;
